import { render, staticRenderFns } from "./PartnerAddResponsible.vue?vue&type=template&id=8c95fa42"
import script from "./PartnerAddResponsible.vue?vue&type=script&lang=js"
export * from "./PartnerAddResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports